import React, { useEffect, useState } from 'react';

// 如果图片地址不存在则不展示img，防止出现破图
const ImgCom = (props) => {
  const [isShow, setIsShow] = useState(true);

  useEffect(() => {
    setIsShow(true);
  }, [props.src])

  return (
    <>
      {
        isShow ? (
          <img
            onError={() => {
              setIsShow(false);
            }}
            {...props}
          />
        ) : (
          null
        )
      }
    </>
  )
}


export default ImgCom;
